module.exports = {"closeButtonText":"닫기","thumbNailAlt":"이미지 미리 보기","next":"다음 페이지","previous":"이전 페이지","addNote":"메모 추가..."}


//////////////////
// WEBPACK FOOTER
// ./translations/ko.json
// module id = 35
// module chunks = 0